module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MX-5dc3dcf084e2b081da409074e6b06439.png";